import { FormSectionContent } from 'modules/workflowNodeEditors/EditorBody.styled';
import styled from 'styled-components';
import { RadioList } from 'ui/radioList';
import { GroupLabel, TopText } from 'ui/radioList/RadioListStyles';
import { colors, fontWeights, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { QueryBuilderContainer } from 'modules/queryBuilder/legacyQueryBuilder/components/QueryBuilder.styled';
import { FieldContainer } from 'modules/queryBuilder/legacyQueryBuilder/components/criteriaPropertyGroup/CriteriarPropertyGroup.styled';

export const FieldsMatchQueryBuilderWrapper = styled.div<{ isReadOnly: boolean }>`
  // very hacky but because other semantic UI styling applies opacity when disabled
  // we have to selectively apply the disabled styling for the inputs that are not greyed out

  * #typeahead-input[disabled],
  [data-role='date-input'] > input[disabled],
  [data-role='time-input'] > input[disabled] {
    opacity: 0.45;
    border-color: ${colors.grey15};
    cursor: not-allowed;
  }

  ${({ isReadOnly }) =>
    isReadOnly &&
    `
  * [data-test='criteria-long-field-cast-select'] > div, button[disabled] > div > div {
  color: rgba(0,0,0,0.8) !important;
  }
  * [data-test='criteria-long-field-cast-select'] {
    opacity: 1 !important;
  }
  `}

  // overwriting semantic UI styling by using class selectors to apply custom background color
  * .cssQueryBuilderContainer,
  .cssCombinatorDropdown,
  .cssDroppableContainer {
    background-color: ${colors.backgroundSecondary} !important;
  }

  background-color: ${colors.backgroundSecondary};

  ${QueryBuilderContainer} {
    ${FieldContainer} {
      .cssCriteriaPropertyGroupFieldDropdown {
        flex: 3;
      }
    }
  }
`;

export const StyledFormSectionContent = styled(FormSectionContent)`
  background-color: ${colors.backgroundSecondary};
  border: thin solid ${colors.grey15};
  border-radius: ${spacing.quarter};
  padding: ${pxToRem(20)};
  display: flex;
  flex-direction: column;
`;

export const StyledRadioList = styled(RadioList)`
  ${GroupLabel} {
    font-weight: ${fontWeights.bold};
  }

  ${TopText} {
    font-weight: ${fontWeights.regular};
    gap: ${spacing.quarter};
  }
`;
